/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["ب", "ص", "ظ", "ع", "ش", "ن"], ["بامداد", "صبح", "ظهر", "بعدازچاشت", "شب", "نیمه‌شب"], u], [["ب", "ص", "بعد از چاشت", "ع", "ش", "ن"], ["بامداد", "صبح", "ظهر", "بعدازچاشت", "شب", "نیمه‌شب"], u], [["01:00", "04:00"], ["04:00", "12:00"], ["12:00", "13:00"], ["13:00", "19:00"], ["19:00", "24:00"], ["00:00", "01:00"]]];
